import { Typography } from '@material-ui/core'

import { gregorianToJalaali } from '../../../../helpers/date'
import { addCommaToPrice } from '../../../../helpers/numbers'
import { getTranslate, lang } from '../../../../localization'
import { RatePlanForSearch } from '../../../../types/searchAvailability'
import useStyles from './styles/index.styles'

export function totalPriceTooltip(ratePlan: RatePlanForSearch | undefined) {
  const classes = useStyles({ lang })
  return (
    <div className={classes.main} dir={lang === 'fa' ? 'rtl' : 'ltr'}>
      <div className={classes.header}>
        <Typography variant="h5" className={classes.toolTipText}>
          {getTranslate('Price Details')}
        </Typography>
      </div>
      {ratePlan && ratePlan.pricePerDay.length > 0 ? (
        <>
          <div className={classes.content}>
            {ratePlan.pricePerDay.map((d, i) => (
              <div className={classes.dateDetails} key={i}>
                <div className={classes.row}>
                  <Typography variant="h6">
                    {`${getTranslate('Date')}: `}
                  </Typography>
                  <Typography variant="h6">
                    {lang === 'fa' ? gregorianToJalaali(d.date) : d.date}
                  </Typography>
                </div>
                <div className={classes.row}>
                  <Typography variant="h6">{`${getTranslate(
                    'Room Price'
                  )}: `}</Typography>
                  <Typography variant="h6">{`${addCommaToPrice(
                    d.price.afterDiscount.roomPrice
                  )} ${getTranslate(
                    ratePlan.price.currency || ''
                  )}`}</Typography>
                </div>
                {d.price.afterDiscount.childrenPrice > 0 && (
                  <div className={classes.row}>
                    <Typography variant="h6">{`${getTranslate(
                      'Children Price'
                    )}: `}</Typography>
                    <Typography variant="h6">{`${addCommaToPrice(
                      d.price.afterDiscount.childrenPrice
                    )} ${getTranslate(
                      ratePlan.price.currency || ''
                    )}`}</Typography>
                  </div>
                )}
                {d.price.afterDiscount.extraBedPrice > 0 && (
                  <div className={classes.row}>
                    <Typography variant="h6">{`${getTranslate(
                      'Extra Bed Price'
                    )}: `}</Typography>
                    <Typography variant="h6">{`${addCommaToPrice(
                      d.price.afterDiscount.extraBedPrice
                    )} ${getTranslate(
                      ratePlan.price.currency || ''
                    )}`}</Typography>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className={classes.total}>
            <Typography variant="h6">{getTranslate('Total')}</Typography>
            <Typography variant="h6">{`${addCommaToPrice(
              ratePlan.price.afterDiscount.totalPrice
            )} ${getTranslate(ratePlan.price.currency || '')}`}</Typography>
          </div>
        </>
      ) : (
        <>
          <div className={classes.content}>
            <Typography variant="h6">
              {getTranslate('No Data available')}
            </Typography>
          </div>
        </>
      )}
    </div>
  )
}
